import { ContextWithQuery, ContextWithTranslatedQuery, SelectorFn } from "@me8eon/agent";
import { AiClients } from "@me8eon/aiclient";
import { isProbablyEnglish, IsProbablyEnglish, TranslateQuery, translateQuery } from "@me8eon/ai_translate";
import { isErrors } from "@me8eon/errors";
import { BaseMessage, Message } from "@me8eon/messages";


export type TranslateSelector = {
    type: "translate";
    ai: string
    description?: string;
    prompt?: string;

};


export function translateToEnglishSelector<Context extends ContextWithQuery & ContextWithTranslatedQuery>(aiClients: AiClients,
                                                                                                          _translate: TranslateQuery = translateQuery,
                                                                                                          _isProbablyEnglish: IsProbablyEnglish = isProbablyEnglish):
    SelectorFn<Context, TranslateSelector> {
    return {
        isDefinedAt: () => true,
        execute: async ({ ai, prompt }, context, messages) => {
            const { query } = context;
            if (!query) return { errors: ["No query found in context for translateSelector"], log: "translateSelector.noQueryInContext" };
            if (_isProbablyEnglish(query))
                return { value: { context: { ...context, translatedQuery: query }, selected: "unknown", messages }, log: { whatHappened: "translateSelector.alreadyEnglish", params: { query } } };
            else {
                const aiClient = aiClients[ai];
                if (!aiClient) return { errors: [`No AI client found for ${ai} in translateSelector. Legal values are ${Object.keys(aiClients).sort().join(", ")}`], log: "translateSelector.noAiClient" };
                const translated = await _translate(aiClient, { targetLanguage: "English", query, prompt });
                if (isErrors(translated)) return { errors: translated.errors, log: { whatHappened: "translateSelector.error", params: { ai, query, prompt, translatedExtras: translated.extras } } };
                const newContext: Context = { ...context, translatedQuery: translated.value };
                return {
                    value: { context: newContext, selected: "unknown", messages},
                    log: {
                        whatHappened: "translateSelector.success",
                        params: { query, translatedQuery: translated.value, ai, prompt },
                    },
                };
            }
        },
    };
}
